"use client";

import dynamic from "next/dynamic";
import { Controller } from "react-hook-form";
import { ArticleStates, AdminCommonCategoriesSelect } from "@/entities";
import { Panel, PanelBody, PanelHeader, useCommonConfigStore } from "@/shared";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Ckeditor = dynamic(() => import("@/shared/admin/ui/editor/ckeditor"), {
  ssr: false,
});

interface Props {
  panelTitle: string;
  control: any;
  errors: any;
  watch: any;
  setValue: any;
  timestamp: any;
}
export const AdminArticleForm = ({
  panelTitle,
  control,
  errors,
  watch,
  setValue,
  timestamp,
}: Props) => {
  const { commonConfig } = useCommonConfigStore();

  return (
    <Panel>
      <PanelHeader>{panelTitle}</PanelHeader>
      <PanelBody>
        <div>
          <Controller
            name="state"
            control={control}
            rules={{
              required: "상태을 입력해주세요.",
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="mb-3">
                <label className="form-label">상태 *</label>
                <select
                  className="form-select form-select-md"
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value}
                >
                  {ArticleStates.filter((item) => item.key !== "delete").map(
                    (item, index) => {
                      return (
                        <option key={index} value={item.key}>
                          {item.value}
                        </option>
                      );
                    }
                  )}
                </select>
                {errors.state && (
                  <span className="text-red errorText">
                    {errors.state.message as string}
                  </span>
                )}
              </div>
            )}
          />
          {commonConfig.is_category && (
            <Controller
              name="common_category_id"
              control={control}
              rules={{
                required: "분류를 선택해주세요.",
              }}
              render={({ field: { onChange, value } }) => (
                <div className="mb-3">
                  <label className="form-label">분류 *</label>
                  <AdminCommonCategoriesSelect
                    table={commonConfig.table}
                    slug={commonConfig.slug}
                    defalutValue={{ key: "", value: "분류 선택" }}
                    onChange={onChange}
                    value={value}
                  />
                  {errors.common_category_id && (
                    <span className="text-red errorText">
                      {errors.common_category_id.message as string}
                    </span>
                  )}
                </div>
              )}
            />
          )}

          <Controller
            name="title"
            control={control}
            rules={{
              required: "제목을 입력해주세요.",
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <div className="mb-3">
                <label className="form-label">제목 *</label>
                <input
                  type="text"
                  className="form-control form-control-md"
                  title="제목을 입력해주세요."
                  placeholder="제목을 입력해주세요."
                  onChange={onChange}
                  onBlur={onBlur}
                  value={value || ""}
                />
                {errors.title && (
                  <span className="text-red errorText">
                    {errors.title.message as string}
                  </span>
                )}
              </div>
            )}
          />

          <Controller
            name="desc"
            control={control}
            rules={{
              required: "내용을 입력해주세요.",
            }}
            render={({ field: { onChange, value } }) => (
              <div className="mb-3">
                <label className="form-label">설명 *</label>
                <Ckeditor
                  onChange={onChange}
                  value={value}
                  table="article"
                  column="desc"
                  timestamp={timestamp}
                />
                {errors.desc && (
                  <span className="text-red errorText">
                    {errors.desc.message as string}
                  </span>
                )}
              </div>
            )}
          />

          <Controller
            name="created_at"
            control={control}
            rules={{
              required: "등록일시를 입력해주세요.",
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <div>
                <label className="form-label">등록일시 *</label>
                <div>
                  <DatePicker
                    selected={value}
                    onChange={onChange}
                    className="form-control form-control-md"
                    dateFormat={"yyyy-MM-dd"}
                  />
                  {errors.created_at && (
                    <span className="text-red errorText">
                      {errors.created_at.message as string}
                    </span>
                  )}
                </div>
              </div>
            )}
          />
        </div>
      </PanelBody>
    </Panel>
  );
};
